import { getAlternativeTextCardReason } from '@wix/a11y-rules';
import { convertBooleanStatusToElementStatus } from '../../../components/fixers/alt-image-fixer/utils';
const getGlobalSectionElementStatus = globalSectionElementState => {
  const updatedStatus = convertBooleanStatusToElementStatus(!!(globalSectionElementState != null && globalSectionElementState.isDecorative) || !!(globalSectionElementState != null && globalSectionElementState.alt) && getAlternativeTextCardReason(globalSectionElementState.alt) === undefined);
  return updatedStatus;
};
export const getUpdatedAltTextImagesFromState = (baseImages, stateMap, globalSectionStateMap) => {
  if (stateMap === undefined && globalSectionStateMap === undefined) {
    return baseImages;
  }
  const updatedImages = [];
  baseImages.forEach(baseImage => {
    const globalSectionElementState = globalSectionStateMap == null ? void 0 : globalSectionStateMap.get(baseImage.id);
    const hasGlobalAltTextChange = (globalSectionElementState == null ? void 0 : globalSectionElementState.alt) !== undefined || (globalSectionElementState == null ? void 0 : globalSectionElementState.isDecorative) !== undefined;
    const imageState = stateMap == null ? void 0 : stateMap.get(baseImage.id);
    if (imageState !== undefined || globalSectionElementState !== undefined) {
      const updatedImage = {
        ...baseImage,
        alt: (globalSectionElementState == null ? void 0 : globalSectionElementState.alt) ?? (imageState == null ? void 0 : imageState.alt) ?? baseImage.alt,
        isDecorative: (globalSectionElementState == null ? void 0 : globalSectionElementState.isDecorative) ?? (imageState == null ? void 0 : imageState.isDecorative) ?? baseImage.isDecorative,
        status: hasGlobalAltTextChange ? getGlobalSectionElementStatus(globalSectionElementState) : (imageState == null ? void 0 : imageState.status) ?? baseImage.status
      };
      updatedImages.push(updatedImage);
    } else {
      updatedImages.push(baseImage);
    }
  });
  return updatedImages;
};
//# sourceMappingURL=get-updated-alt-text-images-from-state.js.map